/*eslint-disable*/
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { useState } from 'react'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const AddAccomodationModal = ({ closeModal, value, handleRoom }: IAddAccomodationModal) => {
    const [state, setState] = useState<IRoom>(value || {
        name: '',
        numberOfBeds: null,
        notes: ''
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, valueAsNumber } = e.target
        setState(prev => ({ ...prev, [name]: name == 'numberOfBeds' ? valueAsNumber : value }))
    }

    const handleSave = () => {
        handleRoom(state)
        closeModal()
    }

    return <Modal black >
        <Flex column center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Room</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input name='name' placeholder='Room 1, Room 2...' labelText='Name' value={state.name} onChange={handleChange} nomarg invalid={!state.name} />
                <Input name='numberOfBeds' placeholder='1, 2, 3...' labelText='Beds' value={state.numberOfBeds} onChange={handleChange} type='number' nomarg invalid={state.numberOfBeds < 1} />
                <Input type='textarea' name='notes' minHeight='200px' placeholder='Note about the room' labelText='Notes' value={state.notes} onChange={handleChange} nomarg />
            </Flex>
            <Button mt='40' orange onClick={handleSave} disabled={!state.name || state.numberOfBeds < 1} >Save</Button>
        </Flex>
    </Modal>
}

export interface IAddAccomodationModal {
    closeModal: () => void
    value: IRoom
    handleRoom: (room: IRoom) => void
}

export interface IRoom {
    id?: number
    name: string
    numberOfBeds: number
    notes: string
}
